import React, {useState} from 'react';
import ArrTextArea from '../../../components/common/arr-text-area/ArrTextArea';

const mockProps = {
  label: 'Description',
  placeholder: 'Enter your description here...',
  value: '',
  rows: 5,
  disabled: false,
  helperText: 'Max 500 characters',
  required: true,
};

const TextAreaDemo: React.FC = () => {
  const [value, setValue] = useState('This is some initial text for the demo.');

  return (
    <div style={{maxWidth: 500, padding: '1rem'}}>
      <ArrTextArea {...mockProps} value={value} onChange={setValue} />
    </div>
  );
};

export default TextAreaDemo;
